import { render } from "./ButtonCloseFilter.vue?vue&type=template&id=5a5495d6&ts=true"
import script from "./ButtonCloseFilter.vue?vue&type=script&lang=ts"
export * from "./ButtonCloseFilter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__